import React from "react";
// import { Component } from "react";
import { TRANSPOTER_GSTIN } from "../config/config.js";
import "./ComponentToPrint.css";
import { groupInfo } from "../config/Biltyform.js";
import { TRANSPORTER_NAME } from "../config/config";
let delivery_at = ["DOOR_DLY", "GODOWN_TPT", "PRIORITY"];
let dict = {};
class ComponentToPrint extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    console.log("debug");
    var packing_type = ['CARTOON', 'CARGO', 'BAG', 'BUNDLE', 'BUCKET', 'CASE', 'BARREL', 'DRUM', 'LOOSE', 'BALE', 'ROLL', 'Carboy', 'BORA', 'BOX', 'W. CASE', "CARAT", "Jumbo Bag", "Pallet"];
    return (
        <div id="bilty-print">
          <div id="main">

            <div id='r1col2-lrno'>
              <label id='r1col2-lrno-label'>{this.props.fields.bilty_no}</label>
            </div>
            <div id="r1col2-date">
              <label id="r1col2-date-label">
                {String(this.props.fields.input_date.getUTCDate()) +
                  "/" +
                  String(this.props.fields.input_date.getUTCMonth() + 1) +
                  "/" +
                  String(this.props.fields.input_date.getUTCFullYear()) +
                  " " +
                  new Date().getHours() +
                  ":" +
                  new Date().getMinutes()}
              </label>
            </div>
            <div id="r1col2-from">
              <label id="r1col2-from-label">
                {this.props.fields.station_from_name}
              </label>
            </div>
            <div id="r1col2-to">
              <label id="r1col2-to-label">
                {this.props.fields.station_to_name}
              </label>
            </div>
            <div id="r2col1">
              <label id="consignor">
                {this.props.fields.consignor_name}
              </label>&nbsp; &nbsp; &nbsp; &nbsp;
              <label id="consignorGst">
                {this.props.fields.consignor_gst}
              </label>
            </div>
            <div id="r2col2" style={{}}>
              <label id="consignee">
                {this.props.fields.consignee_name}
              </label>&nbsp; &nbsp; &nbsp; &nbsp;
              <label id="consigneeGst">
                {this.props.fields.consignee_gst}
              </label>
            </div>

            <div id="r3-no-of-articles">
              <label>
                {this.props.fields.item_in.map((d) => (
                  <React.Fragment>
                    {d.pkgs} <br></br>
                  </React.Fragment>
                ))}
              </label>
            </div>
            <div id='r3-method-packaging'>
              <label>
                {this.props.fields.item_in.map((d) => (
                  <React.Fragment>{packing_type[d.packing_type - 1]} <br></br> </React.Fragment>
                ))}
              </label>
            </div>
            <div id="r3-description">
              <label>
                {this.props.fields.item_in.map((d) => (
                  <React.Fragment>
                    {d.item_name} <br></br>
                  </React.Fragment>
                ))}
              </label>
            </div>
            <div id="r3-remarks"><label>{this.props.fields.remarks}</label></div>
            <div id="delivery-at">
              <label id="owner-risk-mr-no-label">{delivery_at[this.props.fields.delivery_dest_type-1]}</label>
            </div>
            <div id="r3-weight">
              <label>
                {this.props.fields.actual_weight}
              </label>
            </div>


            <div id='r3-freight'><label>
              {groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? "0" : this.props.fields.new_freight}
            </label></div>

            <div id='r3-hamali'><label>{groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "Paid"
              ? "0" : this.props.fields.hamali}</label></div>




            <div id="r3-pay-type">
              <label>
                {
                  groupInfo["group-1"][3]["dropdown_items"][
                    this.props.fields.pay_type - 1
                  ].label.toUpperCase() == "TO BE BILLED" ? "TBB" : groupInfo["group-1"][3]["dropdown_items"][
                    this.props.fields.pay_type - 1
                  ].label.toUpperCase()
                }
              </label>
            </div>
            <div id="r3-charged">
              <label>
                {this.props.fields.charge_wgt}
              </label>
            </div>
            <div id="r3-private-marka">
              <label>
                {this.props.fields.private_marka_no}</label>
            </div>

            <div id="r3-rate">
              <label>
                {this.props.fields.item_in[0].rate}
              </label>
            </div>
            <div id="r3-total-amount"><label>
              {groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? ""
                : this.props.fields.new_total_amount}</label>
            </div>
            <div id='r3-others'><label>{groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "Paid"
              ? "0" : this.props.fields.other_amount}</label></div>
            <div id='r3-bilty-charge'>
              {groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? ""
                : this.props.fields.bilty_charge}
            </div>
            <div id='r3-collection'>
              {groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? ""
                : this.props.fields.lc_charge}
            </div>
            <div id='r3-ddc'>
              {groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? ""
                : this.props.fields.door_del_charge}
            </div>
            <div id='r3-cartage'>
              {groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? ""
                : this.props.fields.cartage_charge}
            </div>
            <div id='r3-eway-bill'>EWAYBILL-{this.props.fields.eway_bill_no[0]["eway_bill_no"]}</div>
            <div id='r3-value'>{this.props.fields.goods_invoice_value}</div>
            <div id='r3-invoice-no'>{this.props.fields.invoice_no}</div>
          </div>
          <div id="main1">
            <div id='r1col2-lrno'>
              <label id='r1col2-lrno-label'>{this.props.fields.bilty_no}</label>
            </div>
            <div id="r1col2-date">
              <label id="r1col2-date-label">
              {String(this.props.fields.input_date.getUTCDate()) +
                  "/" +
                  String(this.props.fields.input_date.getUTCMonth() + 1) +
                  "/" +
                  String(this.props.fields.input_date.getUTCFullYear()) +
                  " " +
                  new Date().getHours() +
                  ":" +
                  new Date().getMinutes()}
              </label>
            </div>
            <div id="r1col2-from">
              <label id="r1col2-from-label">
                {this.props.fields.station_from_name}
              </label>
            </div>
            <div id="r1col2-to">
              <label id="r1col2-to-label">
                {this.props.fields.station_to_name}
              </label>
            </div>
            <div id="r2col1">
              <label id="consignor">
                {this.props.fields.consignor_name}
              </label>&nbsp; &nbsp; &nbsp; &nbsp;
              <label id="consignorGst">
                {this.props.fields.consignor_gst}
              </label>
            </div>
            <div id="r2col2" style={{}}>
              <label id="consignee">
                {this.props.fields.consignee_name}
              </label>&nbsp; &nbsp; &nbsp; &nbsp;
              <label id="consigneeGst">
                {this.props.fields.consignee_gst}
              </label>
            </div>

            <div id="r3-no-of-articles">
              <label>
                {this.props.fields.item_in.map((d) => (
                  <React.Fragment>
                    {d.pkgs} <br></br>
                  </React.Fragment>
                ))}
              </label>
            </div>
            <div id='r3-method-packaging'>
              <label>
                {this.props.fields.item_in.map((d) => (
                  <React.Fragment>{packing_type[d.packing_type - 1]} <br></br> </React.Fragment>
                ))}
              </label>
            </div>
            <div id="r3-description">
              <label>
                {this.props.fields.item_in.map((d) => (
                  <React.Fragment>
                    {d.item_name} <br></br>
                  </React.Fragment>
                ))}
              </label>
            </div>
            <div id="r3-remarks"><label>{this.props.fields.remarks}</label></div>
            <div id="delivery-at">
              <label id="owner-risk-mr-no-label">{delivery_at[this.props.fields.delivery_dest_type-1]}</label>
            </div>
            <div id="r3-weight">
              <label>
                {this.props.fields.actual_weight}
              </label>
            </div>


            <div id='r3-freight'><label>
              {groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? "0" : this.props.fields.new_freight}
            </label></div>

            <div id='r3-hamali'><label>{groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "Paid"
              ? "0" : this.props.fields.hamali}</label></div>




            <div id="r3-pay-type">
              <label>
                {
                  groupInfo["group-1"][3]["dropdown_items"][
                    this.props.fields.pay_type - 1
                  ].label.toUpperCase() == "TO BE BILLED" ? "TBB" : groupInfo["group-1"][3]["dropdown_items"][
                    this.props.fields.pay_type - 1
                  ].label.toUpperCase()
                }
              </label>
            </div>
            <div id="r3-charged">
              <label>
                {this.props.fields.charge_wgt}
              </label>
            </div>
            <div id="r3-private-marka">
              <label>
                {this.props.fields.private_marka_no}</label>
            </div>

            <div id="r3-rate">
              <label>
                {this.props.fields.item_in[0].rate}
              </label>
            </div>

            <div id="r3-total-amount"><label>
              {groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? ""
                : this.props.fields.new_total_amount}</label>
            </div>
            <div id='r3-others'><label>{groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "Paid"
              ? "0" : this.props.fields.other_amount}</label></div>
            <div id='r3-bilty-charge'>
              {groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? ""
                : this.props.fields.bilty_charge}
            </div>
            <div id='r3-collection'>
              {groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? ""
                : this.props.fields.lc_charge}
            </div>
            <div id='r3-ddc'>
              {groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? ""
                : this.props.fields.door_del_charge}
            </div>
            <div id='r3-cartage'>
              {groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? ""
                : this.props.fields.cartage_charge}
            </div>
            <div id='r3-eway-bill'>EWAYBILL-{this.props.fields.eway_bill_no[0]["eway_bill_no"]}</div>
            <div id='r3-value'>{this.props.fields.goods_invoice_value}</div>
            <div id='r3-invoice-no'>{this.props.fields.invoice_no}</div>
          </div>
          <div id="main2">
            <div id='r1col2-lrno'>
              <label id='r1col2-lrno-label'>{this.props.fields.bilty_no}</label>
            </div>
            <div id="r1col2-date">
              <label id="r1col2-date-label">
              {String(this.props.fields.input_date.getUTCDate()) +
                  "/" +
                  String(this.props.fields.input_date.getUTCMonth() + 1) +
                  "/" +
                  String(this.props.fields.input_date.getUTCFullYear()) +
                  " " +
                  new Date().getHours() +
                  ":" +
                  new Date().getMinutes()}
              </label>
            </div>
            <div id="r1col2-from">
              <label id="r1col2-from-label">
                {this.props.fields.station_from_name}
              </label>
            </div>
            <div id="r1col2-to">
              <label id="r1col2-to-label">
                {this.props.fields.station_to_name}
              </label>
            </div>
            <div id="r2col1">
              <label id="consignor">
                {this.props.fields.consignor_name}
              </label>&nbsp; &nbsp; &nbsp; &nbsp;
              <label id="consignorGst">
                {this.props.fields.consignor_gst}
              </label>
            </div>
            <div id="r2col2" style={{}}>
              <label id="consignee">
                {this.props.fields.consignee_name}
              </label>&nbsp; &nbsp; &nbsp; &nbsp;
              <label id="consigneeGst">
                {this.props.fields.consignee_gst}
              </label>
            </div>

            <div id="r3-no-of-articles">
              <label>
                {this.props.fields.item_in.map((d) => (
                  <React.Fragment>
                    {d.pkgs} <br></br>
                  </React.Fragment>
                ))}
              </label>
            </div>
            <div id='r3-method-packaging'>
              <label>
                {this.props.fields.item_in.map((d) => (
                  <React.Fragment>{packing_type[d.packing_type - 1]} <br></br> </React.Fragment>
                ))}
              </label>
            </div>
            <div id="r3-description">
              <label>
                {this.props.fields.item_in.map((d) => (
                  <React.Fragment>
                    {d.item_name} <br></br>
                  </React.Fragment>
                ))}
              </label>
            </div>
            <div id="r3-remarks"><label>{this.props.fields.remarks}</label></div>
            <div id="delivery-at">
              <label id="owner-risk-mr-no-label">{delivery_at[this.props.fields.delivery_dest_type-1]}</label>
            </div>
            <div id="r3-weight">
              <label>
                {this.props.fields.actual_weight}
              </label>
            </div>


            <div id='r3-freight'><label>
              {groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? "0" : this.props.fields.new_freight}
            </label></div>

            <div id='r3-hamali'><label>{groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "Paid"
              ? "0" : this.props.fields.hamali}</label></div>

            <div id="r3-pay-type">
              <label>
                {
                  groupInfo["group-1"][3]["dropdown_items"][
                    this.props.fields.pay_type - 1
                  ].label.toUpperCase() == "TO BE BILLED" ? "TBB" : groupInfo["group-1"][3]["dropdown_items"][
                    this.props.fields.pay_type - 1
                  ].label.toUpperCase()
                }
              </label>
            </div>
            <div id="r3-charged">
              <label>
                {this.props.fields.charge_wgt}
              </label>
            </div>
            <div id="r3-private-marka">
              <label>
                {this.props.fields.private_marka_no}</label>
            </div>

            <div id="r3-rate">
              <label>
                {this.props.fields.item_in[0].rate}
              </label>
            </div>
            <div id="r3-total-amount"><label>
              {groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? ""
                : this.props.fields.new_total_amount}</label>
            </div>
            <div id='r3-others'><label>{groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
              this.props.fields.pay_type - 1
            ].label == "Paid"
              ? "0" : this.props.fields.other_amount}</label></div>
            <div id='r3-bilty-charge'>
              {groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? ""
                : this.props.fields.bilty_charge}
            </div>
            <div id='r3-collection'>
              {groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? ""
                : this.props.fields.lc_charge}
            </div>
            <div id='r3-ddc'>
              {groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? ""
                : this.props.fields.door_del_charge}
            </div>
            <div id='r3-cartage'>
              {groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "To Be Billed" || groupInfo["group-1"][3]["dropdown_items"][
                this.props.fields.pay_type - 1
              ].label == "Paid"
                ? ""
                : this.props.fields.cartage_charge}
            </div>
            <div id='r3-eway-bill'>EWAYBILL-{this.props.fields.eway_bill_no[0]["eway_bill_no"]}</div>
            <div id='r3-value'>{this.props.fields.goods_invoice_value}</div>
            <div id='r3-invoice-no'>{this.props.fields.invoice_no}</div>
          </div>
        </div>
    );
  }
}

export default ComponentToPrint;